import React from "react";
import { Flex, Modal, Select, Form, Input } from "antd";
import getCurrentShop from "./get-current-shop";
import SwitchShop from "./switch-shop";
import ShopCard from './card-proxy';

export default () => {
    const [partners, setPartners] = React.useState([]);
    const urlParams = new URLSearchParams(window.location.search);
    const levelId = urlParams.get('levelId') || undefined;
    const shopId = urlParams.get('shopId');
    const [curruntShop, setCurruntShop] = React.useState(null);
    const [currentShopId, setCurrentShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchShop = async () => {
            const shop = await getCurrentShop();
            setCurruntShop(shop);
            setCurrentShopId(shop ? shop.shopId : shopId);
        };
        
        fetchShop();
    }, []);
    
    React.useEffect(() => {
        if (currentShopId) {
            getPartners();
        }
    }, [currentShopId]);

    const getPartners = async () => {
        const params = new URLSearchParams();
        if(shopId) {
            params.append('shopId', shopId);
        }else {
            params.append('shopId', currentShopId);
        }

        if(levelId) {
            params.append('levelId', levelId);
        }

        const response = await fetch(`/api/shop/partner/list?${params.toString()}`);
        const result = await response.json();

        if(result && result.success) {
            setPartners(result.data.rows);
        }
    }

    return (
        <div>
            {/* <Input.Search placeholder="请输入店铺名" style={{width: '100%', marginBottom: 10}} /> */}
            {/* <Table rowKey={'partnerId'} size="small" columns={columns} dataSource={partners} /> */}
            <Flex justify="start" wrap gap={10} align="center">
            {
                partners.map((item, index) => {
                    return (
                        <ShopCard key={item.partnerId} onChange={getPartners} level={item.level} content={item.partnerShop} />
                    )
                })
            }
            </Flex>
        </div>
    )
};